import React from 'react';
import { renderRoot, unmountRoot } from '../../lib/react_root';
import SMSMessenger from '../../components/SMSMessenger';

const AdministrationSmsMessages = {
  init() {
    const smsContainer = window.document.getElementById('js-sms-global-view');
    if (!smsContainer) return;

    renderRoot(<SMSMessenger />, smsContainer);
  },

  teardown() {
    const smsContainer = window.document.getElementById('js-sms-global-view');
    if (smsContainer) {
      unmountRoot(smsContainer);
    }
  }
}

export default AdministrationSmsMessages;
